/*global tinymce, jQuery */

;(function (tinymce, $) {
  'use strict';

  var A51Code = function (ed) {
    this.editor = ed;

    this.editor.addCommand("a51ToggleCode", () => {
      this.toggleWrap();
    });
  };

  A51Code.prototype = {

    constructor : A51Code,

    toggleWrap: function () {
      var currentNode = this.editor.selection.getNode(),
        selectedText = this.editor.selection.getContent(),
        content = this.editor.dom.createHTML('pre', null, selectedText);

      if (currentNode && $(currentNode).is('pre')) {
        content = $(currentNode).html();
        this.editor.dom.remove(currentNode);

        if (content === '&nbsp;') content = '';
      }

      this.editor.insertContent(content);
    }
  };

  tinymce.PluginManager.add('a51code', function(ed, url){
    new A51Code(ed);
  });
})(tinymce, jQuery);
